var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFraud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#515864",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.827 17.102l-6.039 3.047a.485.485 0 00-.27.426c0 3.652.819 6.025 2.038 7.694 1.22 1.669 2.811 2.604 4.239 3.453a.565.565 0 00.56 0c1.428-.849 3.018-1.784 4.239-3.453 1.22-1.669 2.038-4.042 2.038-7.694a.486.486 0 00-.269-.426l-6.04-3.047a.551.551 0 00-.496 0zm.248.972v12.671c-1.333-.797-2.647-1.629-3.661-3.018-1.055-1.442-1.801-3.534-1.845-6.876l5.506-2.777zM13.714 32a3.439 3.439 0 003.43-3.43h-6.858A3.427 3.427 0 0013.714 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.518 20.586a1.488 1.488 0 01.819-1.33L24 18.418v-4.877c0-4.891-2.811-8.985-7.714-10.069V2.389c0-1.322-1.15-2.389-2.572-2.389-1.422 0-2.571 1.067-2.571 2.389v1.083c-4.92 1.084-7.714 5.162-7.714 10.069v7.965l-3.43 3.186v1.593h22.393c-.585-1.608-.874-3.496-.874-5.699"
  }))));
}
export default SvgFraud;